import _ from "lodash";

import { getStructuredData } from "UnitPlanDetails/routes/IBPlanner/modules/Utils";

const getModuleId = () => {
  const pathname = window.location.pathname;
  return _.last(_.split(pathname, "/"));
};

const VISIBLE_ELEMENT_TYPES_FOR_V2 = ["CARD", "CHECKLIST"];

export const getPlannerElementTypesFromTemplate = template => {
  const fieldListV2 = _.get(template, "body.fieldListV2", {});
  const moduleId = getModuleId();

  const structuredData = getStructuredData({
    template,
    module_id: moduleId,
  });

  const fieldsSet = new Set();
  const plannerElementTypes = [];

  _.forEach(structuredData, section => {
    _.forEach(section.steps, step => {
      _.forEach(step.fields, field => {
        if (field.id) {
          fieldsSet.add(field.id);
        }
      });

      const elementTypes = _.get(step, "config.elementTypes");
      if (!_.isEmpty(elementTypes)) {
        _.forEach(elementTypes, type => plannerElementTypes.push(type));
      }
    });
  });

  // Remove this logics when we introduce plannerElementNodeSet in v2 fields
  const visibleElementTypesSet = new Set();

  _.forEach(Array.from(fieldsSet), field => {
    if (_.has(fieldListV2, field)) {
      const uiType = _.get(fieldListV2[field], "uiType.value");
      if (_.includes(VISIBLE_ELEMENT_TYPES_FOR_V2, uiType)) {
        visibleElementTypesSet.add(uiType);
      }
    }
  });

  return _.union(plannerElementTypes, Array.from(visibleElementTypesSet));
};

export const getDatasetIdsFromTemplate = template => {
  const moduleId = getModuleId();

  const structuredData = getStructuredData({
    template,
    module_id: moduleId,
  });

  const fields = _.uniq(
    _.flatMap(structuredData, section => {
      return _.flatMap(section.steps, step => {
        return _.flatMap(step.fields, field => field.id || []);
      });
    })
  );

  const fieldListV2 = _.get(template, "body.fieldListV2", {});

  const datasetIds = _.reduce(
    _.filter(fields, field => _.has(fieldListV2, field)),
    (setIds, field) => {
      const setId = _.get(fieldListV2[field], "plannerElementSetId.value");
      return setId ? [...setIds, setId] : setIds;
    },
    []
  );

  return datasetIds;
};
